module.exports = __webpack_public_path__ + "img/dark-blue-gradient.27687ab9.svg";